import React from "react";

export type TUnwatchIconProps = React.SVGAttributes<SVGElement>;

export function UnwatchIcon({ ...rest }: TUnwatchIconProps) {
  return (
    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <mask id="mask0_2400_2740"
        mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="26" height="26">
        <rect width="26" height="26" fill="#F36564" />
      </mask>
      <g mask="url(#mask0_2400_2740)">
        <path d="M17.1 14.3L15.65 12.85C15.8 12.0667 15.575 11.3334 14.975 10.65C14.375 9.96672 13.6 9.70005 12.65 
        9.85005L11.2 8.40005C11.4833 8.26672 11.7708 8.16672 12.0625 8.10005C12.3542 8.03338 12.6667 8.00005 13 
        8.00005C14.25 8.00005 15.3125 8.43755 16.1875 9.31255C17.0625 10.1875 17.5 11.25 17.5 12.5C17.5 12.8334 17.4667 
        13.1459 17.4 13.4375C17.3333 13.7292 17.2333 14.0167 17.1 14.3ZM20.3 17.4501L18.85 16.05C19.4833 15.5667 
        20.0458 15.0375 20.5375 14.4626C21.0292 13.8876 21.45 13.2334 21.8 12.5C20.9667 10.8167 19.7708 9.47922 
        18.2125 8.48755C16.6542 7.49588 14.9167 7.00005 13 7.00005C12.5167 7.00005 12.0417 7.03338 11.575 
        7.10005C11.1083 7.16672 10.65 7.26672 10.2 7.40005L8.65 5.85005C9.33333 5.56672 10.0333 5.35422 10.75 
        5.21255C11.4667 5.07088 12.2167 5.00005 13 5.00005C15.5167 5.00005 17.7583 5.69588 19.725 7.08755C21.6917 
        8.47922 23.1167 10.2834 24 12.5C23.6167 13.4834 23.1125 14.3959 22.4875 15.2375C21.8625 16.0792 21.1333 
        16.8167 20.3 17.4501ZM20.8 23.6L16.6 19.4501C16.0167 19.6334 15.4292 19.7709 14.8375 19.8626C14.2458 19.9542 
        13.6333 20 13 20C10.4833 20 8.24167 19.3042 6.275 17.9125C4.30833 16.5209 2.88333 14.7167 2 12.5C2.35 11.6167 
        2.79167 10.7959 3.325 10.0375C3.85833 9.27922 4.46667 8.60005 5.15 8.00005L2.4 5.20005L3.8 3.80005L22.2 
        22.2001L20.8 23.6ZM6.55 9.40005C6.06667 9.83338 5.625 10.3084 5.225 10.825C4.825 11.3417 4.48333 11.9 4.2 
        12.5C5.03333 14.1834 6.22917 15.5209 7.7875 16.5126C9.34583 17.5042 11.0833 18.0001 13 18.0001C13.3333 
        18.0001 13.6583 17.9792 13.975 17.9376C14.2917 17.8959 14.6167 17.85 14.95 17.8L14.05 16.85C13.8667 16.9001 
        13.6917 16.9376 13.525 16.9626C13.3583 16.9875 13.1833 17 13 17C11.75 17 10.6875 16.5625 9.8125 15.6875C8.9375 
        14.8125 8.5 13.75 8.5 12.5C8.5 12.3167 8.5125 12.1417 8.5375 11.975C8.5625 11.8084 8.6 11.6334 8.65 11.45L6.55 
        9.40005Z" fill="#F36564" />
      </g>
    </svg>

  );
}
